<div data-testid="o2o-stuck-alert-page" class="p-6 flex-table-page">
  <div class="mb-4 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ 'o2o.stuck_alert.title' | translate }}
    </h2>
    <p class="text-sm text-gray-500 mt-1">
      {{ 'o2o.stuck_alert.subtitle' | translate }}
    </p>
  </div>

  <div class="mb-4">
    <app-search-form
      [searchFormat]="searchFormConfig()"
      [presetValues]="{ status: 'ACTIVE' }"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    ></app-search-form>
  </div>

  <div class="flex-table-section">
    <app-data-table
      data-testid="o2o-stuck-alert-table"
      [dataSource]="alerts()"
      [columns]="tableColumns"
      [rows]="rows"
      [first]="first()"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
      <ng-template #customTemplate let-value let-column="column">
        @if (column?.template === 'statusTemplate') {
          <p-tag
            [value]="getStatusLabel(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
          />
        }
        @if (column?.template === 'fulfillmentStatusTemplate') {
          <p-tag
            [value]="getFulfillmentStatusLabel(value)"
            [severity]="getFulfillmentStatusSeverity(value)"
            styleClass="status-tag"
          />
        }
        @if (column?.template === 'holdCategoryTemplate') {
          <span class="text-xs text-gray-700">{{ getHoldCategoryLabel(value) }}</span>
        }
        @if (column?.template === 'dateTimeTemplate') {
          <span class="text-xs text-gray-700">{{ getDateTimeLabel(value) }}</span>
        }
      </ng-template>
    </app-data-table>
  </div>
</div>
